import prefs, { Language, ModelRole } from '@/controllers/preferences'

export function makePrompt(lesson: {title: string, prompt: string}, role: ModelRole, language: Language, messages) {
    console.log(role)
  return `
Your role:
${prefs.model_roles[role]}

SPEAK IN ${language.toUpperCase()}

**Lesson Topic:** ${lesson.title}

${lesson.prompt}

**End the lesson with "END LESSON" when all core material is covered.**

Always speak in ${language.toUpperCase()}, no matter what the student speaks in or what your previous messages were in.

Always make sure to follow your role, no matter what your previous messages were.

Discussion so far:

${JSON.stringify(messages)}

\\nothink`
}